import { render, staticRenderFns } from "./amendChildTab.vue?vue&type=template&id=75adbc4c"
import script from "./amendChildTab.vue?vue&type=script&lang=js"
export * from "./amendChildTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports